import { handleStatus500 } from 'api/Utility/HandleStatus500'
import { createQueryString } from 'lib/utility/GetBaseUrl'
import AxiosInitializer from 'api/Utility/AxiosInitializer'
import getToken from 'lib/authentication/GetToken'
import apiWrapper from 'api/Utility/ApiWrapper'
import { DESC } from 'lib/GlobalConstants'

const axiosRequest = (extraParams: any = {}) => {
  const params = {
    token: getToken(),
    ...extraParams,
  }

  return AxiosInitializer({
    ...params,
  })
}

interface ActivitiesReqPayload {
  participantId: string
  projectId: string
  page: number
  perPage: number
}

interface QueryObj {
  page: number
  per_page: number
  filters: {
    sort: { created_at: string }
    tagger_ids?: string
  }
}

const viewNotesEndPoints = {
  viewNotes: (reqObj: ActivitiesReqPayload) => {
    const { participantId, projectId, page, perPage } = reqObj
    const query: QueryObj = {
      page: page,
      per_page: perPage,
      filters: { sort: { created_at: DESC } },
    }
    if (projectId && projectId != '') {
      query['filters']['tagger_ids'] = projectId
    }
    const URL = `/users/${participantId}/admin_notes?${createQueryString(
      query,
    )}`
    return axiosRequest().get(URL)
  },
}

const viewNoteAPI = {
  viewNotes: (reqParams: ActivitiesReqPayload) =>
    apiWrapper({
      endPoint: viewNotesEndPoints.viewNotes,
      params: reqParams,
      errorFailureAction: handleStatus500,
    }),
}

export default viewNoteAPI
